// ============================================================
// 真太阳时校正 —— 专业排盘标配（问真八字／天时子平均有）
// 公式：真太阳时 = 钟表时间 + 经度差×4分钟 + 均时差(EoT)
//   · 中国以东经120°为标准子午线（UTC+8）
//   · EoT ≈ 9.87·sin(2B) − 7.53·cos(B) − 1.5·sin(B)，B=360°(N−81)/365
//     （NOAA 近似式，误差＜1分钟，供排盘参考）
// ============================================================

export const CITIES = [
  { name: '不校正', lon: null, tz: 8 },
  { name: '北京', lon: 116.41, tz: 8 },
  { name: '上海', lon: 121.47, tz: 8 },
  { name: '广州', lon: 113.27, tz: 8 },
  { name: '深圳', lon: 114.06, tz: 8 },
  { name: '杭州', lon: 120.16, tz: 8 },
  { name: '南京', lon: 118.78, tz: 8 },
  { name: '成都', lon: 104.07, tz: 8 },
  { name: '重庆', lon: 106.55, tz: 8 },
  { name: '武汉', lon: 114.31, tz: 8 },
  { name: '西安', lon: 108.95, tz: 8 },
  { name: '郑州', lon: 113.63, tz: 8 },
  { name: '长沙', lon: 112.94, tz: 8 },
  { name: '天津', lon: 117.20, tz: 8 },
  { name: '沈阳', lon: 123.43, tz: 8 },
  { name: '哈尔滨', lon: 126.53, tz: 8 },
  { name: '昆明', lon: 102.72, tz: 8 },
  { name: '乌鲁木齐', lon: 87.62, tz: 8 },
  { name: '拉萨', lon: 91.11, tz: 8 },
  { name: '香港', lon: 114.17, tz: 8 },
  { name: '台北', lon: 121.52, tz: 8 },
  { name: '新加坡', lon: 103.85, tz: 8 },
  { name: '吉隆坡', lon: 101.69, tz: 8 },
  { name: '东京', lon: 139.69, tz: 9 },
];

/** 均时差（分钟），dayOfYear 为年积日 */
export function equationOfTime(year, month, day) {
  const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  const mdays = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let N = day;
  for (let i = 0; i < month - 1; i++) N += mdays[i];
  const B = (2 * Math.PI * (N - 81)) / 365;
  return 9.87 * Math.sin(2 * B) - 7.53 * Math.cos(B) - 1.5 * Math.sin(B);
}

/**
 * @returns null（不校正）或 { hour, minute, lonMin, eotMin, text }
 * 跨午夜时返回的 hour 可能溢出（如 24.2），调用方需按原时辰边界判断前先取整处理：
 * 这里返回带符号总偏移并归一到 0~23:59。
 */
export function trueSolar({ year, month, day, hour, minute, city }) {
  const c = CITIES.find(x => x.name === city);
  if (!c || c.lon == null) return null;
  const total = hour * 60 + minute;
  const lonMin = (c.lon - 120) * 4 + (c.tz - 8) * 60; // 相对东八区标准线的经度差
  const eot = equationOfTime(year, month, day);
  let t = total + lonMin + eot;
  t = ((t % 1440) + 1440) % 1440;
  const h = Math.floor(t / 60);
  const m = Math.round(t % 60);
  return {
    hour: h,
    minute: m,
    crossedMidnight: Math.floor((total + lonMin + eot) / 1440) !== 0,
    lonMin: Math.round(lonMin * 10) / 10,
    eotMin: Math.round(eot * 10) / 10,
    text: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`,
    detail: `经度差 ${Math.round(lonMin * 10) / 10} 分钟 ＋ 均时差 ${Math.round(eot * 10) / 10} 分钟`,
  };
}
